import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Box, Typography, Grid, Container, Modal } from "@mui/material";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { StyledContainer, styles } from "../../../components/formStyles";
import {
  barClubEditRequest,
  barClubViewRequest,
  barClubResetState,
} from "../../../../redux/barclub/BarClubAction";
import { wholesalerSearchViewAllRequest } from "../../../../redux/wholesaler/WholesalerAction";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../constant/commonButton";
import CommonSnackbar from "../../../notification/Snackbar";
import CommonDialog from "../../../notification/Dialogbox";
import { useParams } from "react-router-dom";
import "../../../../style/style.css";
import {
  handleFileChangeMultiImage,
  handleProofChangeMultiImage,
  convertImageToBase64MultiImage,
  convertProofToBase64MultiImage,
  removeImage,
  removeProofImage,
} from "../../../constant/commonFileUpload";
import {
  convertTo24HourFormat,
  formatToAMPM,
} from "../../../constant/commonTimeFormat";
import CloseIcon from "@mui/icons-material/Close";
import { APP_LINK } from "../../../global/MenuItems";
import ReusableFormFields from "../../../constant/reusableFormFields";
import uploadImage from "../../../../image/wmremove-transformed-Photorooms.jpg";
import pdf from "../../../../image/pdf.jpg";
import ImagePreviewDialog from "../../../constant/commonImageDialog";

const EditClub = () => {
  const {
    register,
    handleSubmit,
    setValue,
    control,
    setError,
    getValues,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const [imageFileName, setImageFileName] = useState("");
  const [proofFileName, setProofFileName] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);
  const [proofSelected, setProofSelected] = useState([]);
  const [imagePreview, setImagePreview] = useState([]);
  const [proofPreview, setProofPreview] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(true);
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState([]);
  const [existingImageUrls, setExistingImageUrls] = useState([]);
  const [newImageBase64, setNewImageBase64] = useState([]);
  const [existingProofUrls, setExistingProofUrls] = useState([]);
  const [newProofBase64, setNewProofBase64] = useState([]);
  const [isImageOnlySave, setIsImageOnlySave] = useState(false);

  const [openMap, setOpenMap] = useState(false);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState("");
  const GOOGLE_MAPS_API_KEY = "AIzaSyCvQUUv4zUJSZdBGgDb38rZZakE7qyutZ8";

  const barClubState = useSelector(
    (state) => state?.barClub?.viewBarClub?.data || {}
  );
  const barClubList = barClubState || [];
  const editBarClubState = useSelector((state) => state?.barClub?.editBarClub);

  const wholesalerViewAllState = useSelector(
    (state) => state?.wholesaler?.viewAllSearchWholesaler || {}
  );
  const wholesalerList = wholesalerViewAllState?.data?.data || [];

  useEffect(() => {
    dispatch(wholesalerSearchViewAllRequest());
  }, [dispatch]);

  const dynamicWholesalerOptions = wholesalerList
    ?.filter((wholesaler) => wholesaler?.status === 1)
    ?.map((wholesaler) => ({
      value: wholesaler?.id,
      label: wholesaler?.name,
    }));

  // const dynamicWholesalerOptions = wholesalerList?.map((wholesaler) => ({
  //   value: wholesaler?.id,
  //   label: wholesaler?.name,
  // }));

  const inputFields = [
    {
      name: "reg_no",
      label: "Register No",
      readOnly: true,
    },
    {
      name: "wholesaler_id",
      label: "Choose Wholesaler",
      type: "searchable-select",
      // defaultValue: wholesalerList[0]?.id,
      defaultValue: dynamicWholesalerOptions[0]?.value || "",
      options: dynamicWholesalerOptions,
      size: "selectMedium",
    },
    {
      name: "name",
      label: "Bar/Club Name",
    },
    {
      name: "first_name",
      label: "First Name",
    },
    {
      name: "last_name",
      label: "Last Name",
    },
    {
      name: "email",
      label: "Email Address",
      rules: {
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email format",
        },
      },
    },
    {
      name: "contact",
      label: "Phone No",
      rules: {
        pattern: {
          value: /^\d{8,}$/,
          message: "Invalid Phone Number",
        },
      },
    },
    {
      name: "address",
      label: "Address",
      size: "extraLarge",
    },
    {
      name: "google_map_location",
      label: "Google Map Location",
    },
    {
      name: "latitude",
      label: "Latitude",
    },
    {
      name: "longitude",
      label: "Longitude",
    },
    {
      name: "postal_code",
      label: "Postal Code",
      rules: {
        required: "Postal Code is required",
        pattern: {
          value: /^[0-9]+$/,
          message: "Only numbers are allowed",
        },
      },
    },
    {
      name: "shop_open_and_close_time",
      label: "Shop Time",
      type: "group",
      fields: [
        {
          name: "open_time",
          label: "Shop Opening Time",
          type: "time",
        },
        {
          name: "close_time",
          label: "Shop Closing Time",
          type: "time",
        },
      ],
    },
    {
      name: "status",
      type: "select",
      label: "Status",
      options: [
        { value: "1", label: "Active" },
        { value: "2", label: "InActive" },
      ],
      defaultValue: wholesalerList?.status,
    },
  ];

  const handleImageUpload = (event) => {
    handleFileChangeMultiImage(
      event,
      setNewImageBase64,
      setImagePreview,
      setImageFileName,
      showSnackbar
    );
  };

  const handleProofUpload = (event) => {
    handleProofChangeMultiImage(
      event,
      setNewProofBase64,
      setProofPreview,
      setProofFileName,
      showSnackbar,
      setValue
    );
  };

  const handleCancel = () => {
    navigate(APP_LINK.BARCLUBAGGREGATION);
  };

  useEffect(() => {
    if (id) {
      dispatch(barClubViewRequest(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (!barClubList || !barClubList.bar_image) {
      return;
    }
    setValue("reg_no", barClubList?.reg_no);
    setValue("wholesaler_id", barClubList?.wholesaler_id);
    setValue("first_name", barClubList?.first_name);
    setValue("last_name", barClubList?.last_name);
    setValue("address", barClubList?.address);
    setValue("email", barClubList?.email);
    setValue("contact", barClubList?.contact);
    setValue("name", barClubList?.name);
    setValue("google_map_location", barClubList?.google_map_location);
    setValue("latitude", barClubList?.latitude);
    setValue("longitude", barClubList?.longitude);
    setValue("postal_code", barClubState?.postal_code);
    setValue("status", barClubList?.status);

    const imageUrls = Array.isArray(barClubState?.bar_image)
      ? barClubState.bar_image.filter((img) => img !== null)
      : barClubState?.bar_image
      ? [barClubState.bar_image]
      : [];

    const validImageUrls = imageUrls.filter((url) => url !== uploadImage);
    const convertImagePromises = validImageUrls.map(async (url) => {
      return convertImageToBase64MultiImage(url);
    });

    Promise.all(convertImagePromises).then((base64Images) => {
      setExistingImageUrls(base64Images);
      setImagePreview(validImageUrls);
    });

    // Process proof images
    const proofUrls = Array.isArray(barClubState?.govt_id_image)
      ? barClubState.govt_id_image.filter((img) => img !== null)
      : barClubState?.govt_id_image
      ? [barClubState.govt_id_image]
      : [];

    const validProofUrls = proofUrls.filter((url) => url !== uploadImage);
    const convertProofPromises = validProofUrls.map((url) =>
      convertProofToBase64MultiImage(url)
    );

    Promise.all(convertProofPromises).then((base64ProofImages) => {
      setExistingProofUrls(base64ProofImages);
      setProofPreview(validProofUrls);
    });
  }, [barClubList, setValue]);

  useEffect(() => {
    if (barClubList?.shop_open_and_close_time) {
      const timeParts = barClubList?.shop_open_and_close_time.split(" to ");

      if (timeParts.length === 2) {
        setTimeout(() => {
          setValue("open_time", convertTo24HourFormat(timeParts[0]), {
            shouldDirty: true,
            shouldValidate: true,
          });
          setValue("close_time", convertTo24HourFormat(timeParts[1]), {
            shouldDirty: true,
            shouldValidate: true,
          });
        }, 200);
      } else {
        setValue("open_time", "", { shouldDirty: true, shouldValidate: true });
        setValue("close_time", "", { shouldDirty: true, shouldValidate: true });
      }
    }
  }, [barClubList?.shop_open_and_close_time, setValue, getValues]);

  const handleOpenMap = () => {
    setOpenMap(true);
  };

  const handleCloseMap = () => {
    setOpenMap(false);
    setLatitude(null);
    setLongitude(null);
    setLoading(false);
    setAddress("");
  };

  const fetchAddress = async (lat, lng) => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_MAPS_API_KEY}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      if (data.results && data.results.length > 0) {
        const formattedAddress = data.results[0].formatted_address;
        setAddress(formattedAddress);
        setValue("address", formattedAddress);
      } else {
        setAddress("Address not found");
        setValue("address", "Address not found");
      }
    } catch (error) {
      console.error("Error fetching address:", error);
      setAddress("Error fetching address");
      setValue("address", "Error fetching address");
    } finally {
      setLoading(false);
    }
  };

  const handleMapClick = (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    setLatitude(lat);
    setLongitude(lng);
    setValue("latitude", lat);
    setValue("longitude", lng);
    setValue(
      "google_map_location",
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_MAPS_API_KEY}`
    );
    fetchAddress(lat, lng);
  };

  const onSubmit = async (data) => {
    const { prof_image, profile_image, ...filteredData } = data;

    let barImages = [...existingImageUrls];
    let govtImages = [...existingProofUrls];

    if (newImageBase64.length > 0) {
      barImages = [...barImages, ...newImageBase64];
    }

    if (newProofBase64.length > 0) {
      govtImages = [...govtImages, ...newProofBase64];
    }

    barImages = barImages.filter((img) => img !== null && img !== undefined);
    govtImages = govtImages.filter((img) => img !== null && img !== undefined);

    const editRequestData = {
      ...filteredData,
      id,
      shop_open_and_close_time: `${formatToAMPM(
        data.open_time
      )} to ${formatToAMPM(data.close_time)}`,
      bar_img_url: barImages,
      govt_img_url: govtImages,
    };

    dispatch(barClubEditRequest(id, editRequestData));
  };

  const handleImage = () => {
    if (selectedFile || barClubList?.bar_image_image) {
      const { bar_image, govt_id_image, ...rest } = barClubList;

      const data = {
        ...rest,
        bar_img_url: selectedFile ? [selectedFile] : barClubList?.bar_img_url,
      };

      setIsImageOnlySave(true);
      onSubmit(data);
    } else {
      showSnackbar("Please choose a file before saving.", "error");
    }
  };

  const proofImage = () => {
    if (proofSelected || barClubList?.govt_id_image) {
      const { govt_id_image, bar_image, ...rest } = barClubList;

      const data = {
        ...rest,
        govt_img_url: proofSelected
          ? [proofSelected]
          : barClubList?.govt_img_url,
      };

      setIsImageOnlySave(true);
      onSubmit(data);
    } else {
      showSnackbar("Please choose a file before saving.", "error");
    }
  };

  const handleEditBarClubResponse = () => {
    if (editBarClubState?.error) {
      const errorMessage = editBarClubState?.message;
      const errorFields = editBarClubState?.errorFields || {};
      if (
        typeof errorFields === "object" &&
        Object.keys(errorFields).length > 0
      ) {
        Object.keys(errorFields).forEach((field) => {
          setError(field, {
            type: "manual",
            message: errorFields[field],
          });
        });
      }

      if (errorFields?.name) {
        setError("name", {
          type: "manual",
          message: errorFields.name,
        });
      }

      if (
        !Object.keys(errorFields).length &&
        typeof errorMessage === "string" &&
        errorMessage.trim()
      ) {
        setDialogMessage(errorMessage);
        setIsSuccess(false);
        setDialogOpen(true);
      }
      dispatch(barClubViewRequest(id));
    } else if (editBarClubState?.success) {
      if (isImageOnlySave) {
        showSnackbar("Image/Proof saved successfully!", "success");
        dispatch(barClubViewRequest(id));
      } else {
        setDialogMessage("Bar/Club updated successfully");
        setIsSuccess(true);
        setDialogOpen(true);
        navigate(APP_LINK.BARCLUBAGGREGATION);
      }

      dispatch(barClubResetState());
      // dispatch(barClubViewRequest(id));
      setIsImageOnlySave(false);
    }
  };

  useEffect(() => {
    handleEditBarClubResponse();
  }, [editBarClubState]);

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleImageClick = (image, isPdf = false) => {
    if (isPdf) {
      window.open(image, "_blank");
    } else if (image !== uploadImage) {
      setSelectedImage(image);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={5}>
            <Box>
              <Typography
                variant="h5"
                gutterBottom
                sx={styles.title}
                className="headingTable"
              >
                <h1> Edit Bar/Club Information</h1>
              </Typography>
              <Typography variant="p" gutterBottom sx={styles.photoHeading}>
                Upload Images of Bar/Club
              </Typography>
            </Box>
            <Box>
              <StyledContainer>
                <Grid container spacing={6}>
                  {imagePreview.length > 0 ? (
                    imagePreview.map((preview, index) => (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={2}
                        xl={2}
                        key={index}
                      >
                        <Box sx={styles.imageUploadClosePosition}>
                          {/* Image Preview */}
                          <img
                            src={preview}
                            alt={`Image ${index + 1}`}
                            width={80}
                            height={80}
                            style={styles.imageUploadCloseContain}
                            onClick={() => handleImageClick(preview)}
                          />

                          {/* Close (Remove) Button */}
                          <button
                            type="button"
                            onClick={() =>
                              removeImage(
                                index,
                                setSelectedImage,
                                setImagePreview,
                                setExistingImageUrls
                              )
                            }
                            style={styles.imageUploadClose}
                          >
                            <CloseIcon fontSize="small" />
                          </button>
                        </Box>
                      </Grid>
                    ))
                  ) : (
                    <Grid item xs={12} sm={6} md={12} lg={2} xl={2}>
                      <img
                        src={uploadImage}
                        alt="Default Upload Image"
                        width={80}
                        height={80}
                        style={styles.image}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} sm={12} md={12} lg={10} xl={10}>
                    <Typography
                      variant="p"
                      gutterBottom
                      sx={styles.photoContent}
                    >
                      Upload Actual Photos of Bar/Club, size less than 2MB
                    </Typography>
                    <Box sx={styles.fileButtonContainer}>
                      <CustomButton
                        variant="outlined"
                        component="label"
                        size="small"
                        buttonStyle="chooseFileButton"
                      >
                        Choose File
                        <input
                          type="file"
                          hidden
                          multiple
                          onChange={handleImageUpload}
                        />
                      </CustomButton>
                      <CustomButton
                        variant="contained"
                        size="small"
                        buttonStyle="fileNameButton"
                        selectedFile={Boolean(selectedFile)}
                      >
                        {imageFileName || "No File Chosen"}
                      </CustomButton>
                    </Box>
                    <Box sx={styles.saveButtonContainer}>
                      <CustomButton
                        text="Save"
                        buttonStyle="saveButton"
                        onClick={handleImage}
                        size="small"
                      >
                        Save
                      </CustomButton>
                    </Box>
                  </Grid>
                </Grid>
              </StyledContainer>
              <Typography variant="body2" gutterBottom sx={styles.note}>
                <span style={{ color: "red" }}>Note:</span> Only JPEG or PNG
                format is supported <span style={{ color: "red" }}>*</span>
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={5}>
            <Box sx={styles.fileBoxContainer}>
              <Typography variant="p" gutterBottom sx={styles.photoHeading}>
                Upload Govt ID Proof Of Bar/club
              </Typography>
              <StyledContainer>
                <Grid container spacing={6}>
                  {proofPreview.length > 0 &&
                  proofPreview.some((file) => file) ? (
                    proofPreview.map((fileObj, index) => {
                      const fileUrl =
                        typeof fileObj === "string" ? fileObj : fileObj?.url;
                      const isPdf =
                        typeof fileObj === "string"
                          ? fileObj.toLowerCase().endsWith(".pdf")
                          : fileObj?.isPdf ?? false;

                      return (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={4}
                          lg={2}
                          xl={2}
                          key={index}
                        >
                          <Box sx={styles.imageUploadClosePosition}>
                            {isPdf ? (
                              <img
                                src={pdf}
                                alt={`PDF ${index + 1}`}
                                width={80}
                                height={80}
                                style={styles.imageUploadCloseContain}
                                onClick={() => {
                                  handleImageClick(fileUrl, true);
                                }}
                              />
                            ) : (
                              <img
                                src={fileUrl}
                                alt={`Proof ${index + 1}`}
                                width={80}
                                height={80}
                                style={styles.imageUploadCloseContain}
                                onClick={() => {
                                  handleImageClick(fileUrl, false);
                                }}
                              />
                            )}
                            {/* Close (Remove) Button */}
                            <button
                              type="button"
                              onClick={() =>
                                removeProofImage(
                                  index,
                                  setProofSelected,
                                  setProofPreview,
                                  setExistingProofUrls
                                )
                              }
                              style={styles.imageUploadClose}
                            >
                              <CloseIcon fontSize="small" />
                            </button>
                          </Box>
                        </Grid>
                      );
                    })
                  ) : (
                    <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
                      <img
                        src={uploadImage}
                        alt="Default Upload Image"
                        width={80}
                        height={80}
                        style={styles.image}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} sm={12} md={12} lg={10} xl={10}>
                    <Typography
                      variant="p"
                      gutterBottom
                      sx={styles.photoContent}
                    >
                      Upload Actual Photos of Proof, size less than 2MB
                    </Typography>
                    <Box sx={styles.fileButtonContainer}>
                      <CustomButton
                        text="Choose File"
                        variant="outlined"
                        component="label"
                        size="small"
                        buttonStyle="chooseFileButton"
                      >
                        Choose File
                        <input
                          type="file"
                          hidden
                          onChange={handleProofUpload}
                        />
                      </CustomButton>
                      <CustomButton
                        variant="contained"
                        size="small"
                        buttonStyle="fileNameButton"
                        selectedFile={Boolean(proofSelected)}
                        // disabled={!proofFileName}
                      >
                        {proofFileName || "No File Chosen"}
                      </CustomButton>
                    </Box>
                    <Box sx={styles.saveButtonContainer}>
                      <CustomButton
                        text="Save"
                        buttonStyle="saveButton"
                        onClick={proofImage}
                        size="small"
                      >
                        Save
                      </CustomButton>
                    </Box>
                  </Grid>
                </Grid>
              </StyledContainer>
            </Box>
            <Typography variant="body2" gutterBottom sx={styles.note}>
              <span style={{ color: "red" }}>Note:</span> Only JPEG, PDF & PNG
              format is supported <span style={{ color: "red" }}>*</span>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
            <ReusableFormFields
              inputFields={inputFields}
              control={control}
              errors={errors}
              register={register}
              setValue={setValue}
              required={true}
              onFieldClick={handleOpenMap}
            />
            <Box sx={styles.submitGap}>
              <Grid container spacing={2} item xs={12}>
                <Grid item xs={6}>
                  <CustomButton
                    text="Submit"
                    size="medium"
                    type="submit"
                    buttonStyle="StyledButton"
                    disabled={editBarClubState?.inProgress}
                    loading={editBarClubState?.inProgress}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomButton
                    text="Cancel"
                    variant="contained"
                    size="medium"
                    fullWidth
                    buttonStyle="style1"
                    onClick={handleCancel}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </form>
      {/* Snackbar */}
      <CommonSnackbar
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />

      {/* Dialog */}
      <CommonDialog
        open={dialogOpen}
        isSuccess={isSuccess}
        onClose={handleDialogClose}
        redirectPath={APP_LINK.ADDBARAGGREGATION}
        messageSuccess={dialogMessage}
        messageError={dialogMessage}
      />

      {/* Popup Dialog */}
      <ImagePreviewDialog
        open={open}
        onClose={handleClose}
        selectedImage={selectedImage}
        proofSelected={proofSelected}
      />
      <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
        <form onSubmit={handleSubmit(onSubmit)}>
          {/* Your form elements here */}

          {/* Modal for Map */}
          <Modal
            open={openMap}
            onClose={handleCloseMap}
            aria-labelledby="map-modal-title"
            aria-describedby="map-modal-description"
          >
            <Box
              sx={{
                p: 2,
                bgcolor: "white",
                borderRadius: "8px",
                maxWidth: "600px",
                mx: "auto",
                mt: "10%",
              }}
            >
              <h2 id="map-modal-title">Select Location</h2>
              <GoogleMap
                mapContainerStyle={{ width: "100%", height: "400px" }}
                center={{ lat: 12.9716, lng: 77.5946 }}
                zoom={10}
                onClick={handleMapClick}
              >
                {latitude && longitude && (
                  <Marker
                    position={{
                      lat: parseFloat(latitude),
                      lng: parseFloat(longitude),
                    }}
                  />
                )}
              </GoogleMap>
            </Box>
          </Modal>
        </form>
      </LoadScript>
    </Container>
  );
};

export default EditClub;
